import { useTimeSlotDisplayData } from "../../../stores/Appointment/appointment.queries";
import { usePatientsMinimal } from "../../../stores/Patients";
import { PatientMinimalDto } from "../../../api-client";

/**
 * Resolves patient display data from either a timeSlotId (via display-data cache)
 * or a raw patientId (via patients-minimal endpoint).
 *
 * Use this in ShiftRow / PlacementRow / SkippedRow / DraftRequestCard when the
 * timeSlotId might be empty (e.g. newly-created placements).
 */
export function usePatientFromDraft(
  timeSlotId: string | undefined,
  patientId: string | undefined,
): { patient: PatientMinimalDto | undefined; isLoading: boolean } {
  const hasTimeSlot = !!timeSlotId;
  const numericPatientId = patientId ? Number(patientId) : NaN;
  const hasPatientId = !hasTimeSlot && !isNaN(numericPatientId);

  const { data: displayData, isLoading: tsLoading } = useTimeSlotDisplayData(
    timeSlotId ?? "",
    hasTimeSlot && !hasPatientId,
  );

  const { data: patientsMinimal, isLoading: pmLoading } = usePatientsMinimal(
    hasPatientId ? [numericPatientId] : [],
    hasPatientId && !hasTimeSlot,
  );

  if (hasTimeSlot) {
    return { patient: displayData?.patient, isLoading: tsLoading };
  }

  if (hasPatientId) {
    return { patient: patientsMinimal?.[0], isLoading: pmLoading };
  }

  return { patient: undefined, isLoading: false };
}
